import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';

const SuccessMessage = ({
  name,
  email,
  onContinue
}) => {
  return (
    <div className="w-full max-w-md mx-auto p-8 space-y-6 bg-white rounded-xl shadow-lg">
      <div className="text-center">
        <div className="mx-auto flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Félicitations ! 🎉
        </h2>
        
        <p className="text-gray-600 mb-4">
          Votre compte a été créé avec succès
        </p>
        
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
          <h3 className="font-semibold text-green-800 mb-2">
            Bienvenue {name} !
          </h3>
          <p className="text-sm text-green-700">
            Un email de bienvenue a été envoyé à <br />
            <span className="font-medium">{email}</span>
          </p>
        </div>
        
        <div className="space-y-3 text-sm text-gray-600">
          <div className="flex items-center justify-center space-x-2">
            <CheckCircle className="w-4 h-4 text-green-500" />
            <span>Email vérifié</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <CheckCircle className="w-4 h-4 text-green-500" />
            <span>Compte activé</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <CheckCircle className="w-4 h-4 text-green-500" />
            <span>Connexion automatique</span>
          </div>
        </div>
        
        <button
          onClick={onContinue}
          className="w-full mt-6 flex items-center justify-center space-x-2 py-3 px-4 bg-[#008751] text-white rounded-lg hover:bg-[#006d40] transition-colors font-medium"
        >
          <span>Continuer vers l'application</span>
          <ArrowRight className="w-4 h-4" />
        </button>
        
        <p className="mt-4 text-xs text-gray-500">
          Vous serez redirigé automatiquement dans quelques secondes...
        </p>
      </div>
    </div>
  );
};

export default SuccessMessage;